module.exports = __webpack_public_path__ + "img/ysqs.0016bcce.png";